import script from "./ResultReminder.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultReminder.vue?vue&type=script&setup=true&lang=js"

import "./ResultReminder.vue?vue&type=style&index=0&id=7bce56d6&scoped=true&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bce56d6"]])

export default __exports__